import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/icon/Icon';
import Logo from '../../assets/logos/neels_logo.png'

interface IBrandProps {
	asideStatus: boolean;
	setAsideStatus(...args: unknown[]): unknown;
}
const Brand: FC<IBrandProps> = ({ asideStatus, setAsideStatus }) => {
	return (
		<div className='brand'>
			<div className='brand-logo'>
				<h1 className='brand-title '>
					<Link to='/' aria-label='Logo'>
						{/* <Logo height={50} /> */}
						<img src={Logo} alt="" height={50}/>
						{/* <span style={{fontSize:"15px", fontWeight:"normal"}}>Neel's Sanjayraj</span> */}
					</Link>
				</h1>
			</div>
			<button
				type='button'
				className='btn brand-aside-toggle'
				aria-label='Toggle Aside'
				onClick={() => setAsideStatus(!asideStatus)}>
				<Icon icon='FirstPage' className='brand-aside-toggle-close' />
				<Icon icon='LastPage' className='brand-aside-toggle-open' />
			</button>
		</div>
	);
};

export default Brand;
